import type { UserInfo } from '../types';

export const BATCH_SIZE = 90;

/**
 * Fetches user info for any number of account IDs, automatically chunking into
 * batches of BATCH_SIZE (90) to respect the AGG `users(accountIds)` limit.
 * Duplicate account IDs are deduplicated before batching.
 * All batches are fetched in parallel.
 */
export const batchFetchUsers = async (
	accountIds: string[],
	fetchBatch: (ids: string[]) => Promise<UserInfo[]>,
): Promise<UserInfo[]> => {
	const unique = [...new Set(accountIds)];

	if (unique.length === 0) {
		return [];
	}

	const chunks: string[][] = [];
	for (let i = 0; i < unique.length; i += BATCH_SIZE) {
		chunks.push(unique.slice(i, i + BATCH_SIZE));
	}

	const results = await Promise.all(chunks.map((chunk) => fetchBatch(chunk)));
	return results.flat();
};
